"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const SnackbarNotice_1 = require("./SnackbarNotice");
const Css_1 = require("../../Css");
const utils_1 = require("../../utils");
function Snackbar({ notices, offset }) {
    var _a;
    const tid = (0, utils_1.useTestIds)({});
    return ((0, jsx_runtime_1.jsx)("div", { ...tid.snackbarWrapper, css: Css_1.Css.fixed.z999.bottomPx((_a = offset.bottom) !== null && _a !== void 0 ? _a : defaultOffset.bottom).left3.df.fdc.aifs.gapPx(12).$, children: notices.map((data) => ((0, jsx_runtime_1.jsx)(SnackbarNotice_1.SnackbarNotice, { ...data }, data.id))) }));
}
exports.Snackbar = Snackbar;
const defaultOffset = {
    bottom: 24,
};
